export { default as isCapacitor } from './isCapacitor';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hilma/tools/dist/functions/index.js
// module id = 82
// module chunks = 1